(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function initRecipeIndex(root) {
    if (!root || root.dataset.kootaRecipesReady === 'true') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-koota-recipe-card]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-recipe-filter]'));
    var search = root.querySelector('[data-recipe-search]');
    var clearSearch = root.querySelector('[data-recipe-search-clear]');
    var reset = root.querySelector('[data-recipe-reset]');
    var count = root.querySelector('[data-recipe-result-count]');
    var empty = root.querySelector('[data-recipe-empty]');
    var pagination = root.querySelector('[data-recipe-pagination]');
    var active = { type: '', product: '' };

    function update() {
      var query = normalize(search ? search.value : '');
      var visible = 0;

      cards.forEach(function (card) {
        var typeMatch = !active.type || (card.dataset.recipeTypes || '').indexOf('|' + active.type + '|') !== -1;
        var productMatch = !active.product || (card.dataset.recipeProducts || '').indexOf('|' + active.product + '|') !== -1;
        var searchMatch = !query || normalize(card.dataset.recipeSearch).indexOf(query) !== -1;
        var shouldShow = typeMatch && productMatch && searchMatch;

        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      if (count) count.textContent = visible + (document.documentElement.lang.startsWith('en') ? ' recipe' : ' recette') + (visible > 1 ? 's' : '');
      if (empty) empty.hidden = visible !== 0;
      if (clearSearch) clearSearch.hidden = !query;
      if (pagination) pagination.hidden = Boolean(query || active.type || active.product);
    }

    function resetAll() {
      active.type = '';
      active.product = '';
      if (search) search.value = '';

      filters.forEach(function (filter) {
        var selected = filter.dataset.filterValue === '';
        filter.classList.toggle('is-active', selected);
        filter.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      update();
      if (search) search.focus();
    }

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        var group = filter.dataset.filterGroup;
        if (!Object.prototype.hasOwnProperty.call(active, group)) return;

        active[group] = filter.dataset.filterValue || '';
        filters.forEach(function (candidate) {
          if (candidate.dataset.filterGroup !== group) return;
          var selected = candidate === filter;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        update();
      });
    });

    if (search) search.addEventListener('input', update);
    if (clearSearch) {
      clearSearch.addEventListener('click', function () {
        search.value = '';
        search.focus();
        update();
      });
    }
    if (reset) reset.addEventListener('click', resetAll);

    root.dataset.kootaRecipesReady = 'true';
    update();
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(field);
      }
    });
  }

  function initRecipeArticle(root) {
    if (!root || root.dataset.kootaRecipeReady === 'true') return;

    var printButton = root.querySelector('[data-koota-recipe-print]');
    var shareButton = root.querySelector('[data-koota-recipe-share]');
    var status = root.querySelector('[data-koota-recipe-status]');
    var statusTimer;

    function announce(message) {
      if (!status) return;
      window.clearTimeout(statusTimer);
      status.textContent = message;
      statusTimer = window.setTimeout(function () {
        status.textContent = '';
      }, 3000);
    }

    if (printButton) {
      printButton.addEventListener('click', function () {
        window.print();
      });
    }

    if (shareButton) {
      shareButton.addEventListener('click', function () {
        var url = shareButton.dataset.shareUrl || window.location.href;
        var title = shareButton.dataset.shareTitle || document.title;

        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function (error) {
            if (error && error.name === 'AbortError') return;
            copyText(url).then(function () {
              announce(document.documentElement.lang.startsWith('en') ? 'Link copied!' : 'Lien copié !');
            });
          });
          return;
        }

        copyText(url)
          .then(function () {
            announce(document.documentElement.lang.startsWith('en') ? 'Link copied!' : 'Lien copié !');
          })
          .catch(function () {
            announce('Impossible de copier le lien.');
          });
      });
    }

    root.dataset.kootaRecipeReady = 'true';
  }

  function init(scope) {
    var context = scope || document;
    var indexes = context.matches && context.matches('[data-koota-recipes]')
      ? [context]
      : context.querySelectorAll('[data-koota-recipes]');
    var articles = context.matches && context.matches('[data-koota-recipe]')
      ? [context]
      : context.querySelectorAll('[data-koota-recipe]');

    Array.prototype.forEach.call(indexes, initRecipeIndex);
    Array.prototype.forEach.call(articles, initRecipeArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
